module.exports = __webpack_public_path__ + "img/sending_2.b99e302b.png";